import React, { PropsWithChildren, ReactNode } from 'react';

import { BreakpointProvider } from '@rakutenfrance/breakpoint';
import { GtmProvider } from '@rakutenfrance/gtm-provider';

import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { hypernovaWrapperClassName } from '../utils/hypernovaWrapperClassName';

import { useStore, useApollo } from '@rakutenfrance/redux-apollo-helper';
import { MUIProvider } from '@rakutenfrance/mui';
import { MarketplaceProvider } from '@rakutenfrance/tolgee-provider';

import { ReduxApolloFragmentWrapperChildrenType } from '../types';

// @ts-expect-error css
import s from './Wrapper.module.css';

interface WrapperProps {
  children: ReactNode;
}
export const Wrapper: React.FC<WrapperProps> = ({ children }) => {
  return (
    // use data-role="none" data-enhance="false" to disable jquery mobile "enhancing" of the html
    <div className={hypernovaWrapperClassName} data-role="none" data-enhance="false">
      <div className={s.background}>
        <BreakpointProvider>
          <GtmProvider>
            <MarketplaceProvider>{children}</MarketplaceProvider>
          </GtmProvider>
        </BreakpointProvider>
      </div>
    </div>
  );
};

//
// export const ReduxApolloFragmentWrapper: React.FC<RootFragmentType> = ({
//   Component,
//   initialReduxState,
//   initialApolloState,
//   moduleName,
//   ...componentPros
// }) => {
//   const store = useStore(initialReduxState, Component.reducers);
//   const apolloClient = useApollo(initialApolloState);
//
//   return (
//     <Provider store={store}>
//       <ApolloProvider client={apolloClient}>
//         <MUIProvider moduleName={moduleName}>
//           <Wrapper>
//             <Component {...componentPros} />
//           </Wrapper>
//         </MUIProvider>
//       </ApolloProvider>
//     </Provider>
//
//   );
// };

export const ReduxApolloFragmentWrapperChildren: React.FC<PropsWithChildren<ReduxApolloFragmentWrapperChildrenType>> = ({
  children,
  initialReduxState,
  initialApolloState,
  reducers,
}) => {
  const store = useStore(initialReduxState, reducers);
  const apolloClient = useApollo(initialApolloState);

  const htmlFontSize = 10; // SSR default font Size, used in Canopy

  // us a css based dynamic css fontsize ajust as in css files transpiled by the postcss pluging where all rem values get ajusted see 'postcss-rem-to-rem-multiplier'
  // this is needed because different monolith pages have different <html> fontsize values. e.g. 13px, 12px, 16px.
  // a js in monolith is setting the css var --hyp-rem-multi earl in the page load, this react js is loaded later
  // css will look like this calc(1.2rem * var(--hyp-rem-multi))
  const pxToRem = (size: number): string => `calc(${size / htmlFontSize}rem * var(--hyp-rem-multi))`;

  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <MUIProvider htmlFontSize={htmlFontSize} pixToRem={pxToRem}>
          <Wrapper>{children}</Wrapper>
        </MUIProvider>
      </ApolloProvider>
    </Provider>
  );
};
